<template>
  <div class="sidebar" :style="{ height: height }" style="overflow:overlay">
    <menucpn :sidebarData.sync="menuData"></menucpn>
  </div>
</template>
<script>
import Menucpn from "../tools/Menu";
export default {
  name: "Sidebar",
  components: { Menucpn },
  props: {
    height: {
      type: String,
      default: "100%"
    },
    sidebarData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    treeFlag(tree) {
      const that = this;
      tree.forEach(ele => {
        ele.open = false;
        if (ele.Subset && ele.Subset.length !== 0) {
          that.treeFlag(ele.Subset);
        }
      });
    }
  },
  computed: {
    menuData() {
      const list = JSON.parse(JSON.stringify(this.sidebarData));
      this.treeFlag(list);
      return list;
    }
  }
};
</script>
<style lang="scss" scoped>
/*.sidebar {*/
/*  background-color: #545c64;*/
/*  float: left;*/
/*}*/
.el-aside {
  margin-bottom: 0;
  padding:0;
}
</style>
